import { Navigate } from "react-router-dom";

export const PrivateRoute = ({ children }) => {
  try {
    const user = localStorage.getItem("user");
    // Redirect if no user
    if (!user) {
      return <Navigate to="/login" replace />;
    }

    // Otherwise show the page
    return children;
  } catch (error) {
    console.error('PrivateRoute error:', error);
    return <Navigate to="/login" replace />;
  }
};